// extracted by mini-css-extract-plugin
export default {"maincontent":"content_maincontent__C+E-t"};